import { Box, Typography } from '@mui/material';

const PreviewTooltipContent = ({
  timeRef,
  period,
  periodType,
  code,
  periodAbs,
  factsheetVersion
}: {
  timeRef: string;
  period: string;
  periodType: string;
  code: string;
  periodAbs?: string;
  factsheetVersion?: string;
}) => (
  <Box sx={{ display: 'flex' }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'start',

        gap: '20px'
      }}
    >
      {periodAbs && (
        <Box sx={{ minWidth: 35, display: 'flex', flexDirection: 'column' }}>
          <Typography
            color='info'
            variant='inherit'
          >
            PeriodAbs
          </Typography>
          <Typography variant='inherit'>{periodAbs}</Typography>
        </Box>
      )}
      {factsheetVersion && (
        <Box sx={{ minWidth: 60, display: 'flex', flexDirection: 'column' }}>
          <Typography
            color='info'
            variant='inherit'
          >
            FactsheetVersion
          </Typography>
          <Typography variant='inherit'>{factsheetVersion}</Typography>
        </Box>
      )}
    </Box>
  </Box>
);

export default PreviewTooltipContent;
